<img [src]="url" />
